<template>
  <div>
    <keep-alive>
      <component :is="coms" :cutcoms="cutcoms"></component>
    </keep-alive>
  </div>
</template>

<script>
import { checkCryptoPwd } from "@/api/examination.js";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      isActive: 0,
    };
  },
  components: {
    CertifiedHosp: () => import("./components/IndepenPwa.vue"), // 有tab的页面
    Encryption: () => import("./components/setEncryption.vue"),
    CertifiedPage: () => import("./components/decryTable.vue"), // 去首页直接路由跳转
  },
  computed: {
    coms() {
      switch (this.isActive) {
        case 0:
          return "CertifiedHosp";
        case 1:
          return "Encryption";
        case 2:
          return "CertifiedPage";
      }
      return "ss";
    },
  },
  methods: {
    cutcoms(index) {
      this.isActive = index;
    },
    // 判断是否要独立密码进来的校验接口
    async independent() {
      let params = {
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      const Data = await checkCryptoPwd(params);
      if (Data.status === 200) {
        this.isHavePwd = Data.data.Data.isHavePwd;
        if (this.isHavePwd === 0) {
          // 为0的时候表示没有设置密码去设置密码页面
          this.cutcoms(1);
        } else if (this.isHavePwd === 1) {
          this.cutcoms(0);
        }
      } else {
        this.$message.error("请求失败");
      }
    },
  },
  created() {
    this.independent();
  },
};
</script>